import React from 'react'
import { CallToActionType } from './types'
import { Link } from 'gatsby'

// MUI
import Button from '@mui/material/Button'
import ParrotfishIcon from '../ParrotfishIcon'
import CognigyChatInitializer from '../CogniyChat//CognizyChatInitializer'
import { useLocation } from '@reach/router'

const CallToAction = ({
  buttonText,
  linkTarget,
  trackingId: id,
  trackingIdModule,
  internal: _internal,
  contentful_id: _contentful_id,
  icon,
  inverted = false,
  variant,
  color,
  ctaType = 'LinkCTA',
  ...props
}: CallToActionType) => {
  const location = useLocation()
  if (inverted && variant === 'outlined') variant = 'invertedOutlined'
  if (inverted && variant === 'text') variant = 'invertedText'

  const getTrackingId = () => {
    id && trackingIdModule && (id += `__${trackingIdModule}`)
    return id
  }

  const colorMap = new Map()

  colorMap.set('red', 'secondary')
  colorMap.set('green', 'primary')
  colorMap.set('info', 'info')

  // Define pages where Cognigy should load
  const cognigyPages = ['/kundeservice/internet/', '/kundeservice/faktura/']

  // Check if the current page is a Cognigy-specific page
  const isCognigyPage = cognigyPages.some(page => location.pathname.startsWith(page))
  return ctaType === 'ChatCTA' && isCognigyPage ? (
    <CognigyChatInitializer
      buttonText={buttonText}
      ctaType={ctaType}
      icon={icon}
      variant={variant}
      inverted={inverted}
      color={color}
      {...props}
      isChatCTA
      trackingId={getTrackingId() || ''}
    />
  ) : (
    <Button
      {...props}
      {...(linkTarget && !linkTarget.startsWith('http')
        ? { component: Link, to: linkTarget! }
        : { href: linkTarget!, target: '_blank' })}
      {...(color && { color: colorMap.get(color) })}
      id={getTrackingId() || ''}
      variant={variant ?? 'contained'}
      startIcon={icon ? <ParrotfishIcon {...icon} /> : props.startIcon}
    >
      {buttonText}
    </Button>
  )
}

export default CallToAction
